import { createSelector } from '@ngrx/store';

import { menuFlowDefaultActivationsState } from '../root';

export const isDownloadingAnyMenuFlowDefaultActivation = createSelector(
    menuFlowDefaultActivationsState,
    (menuFlowDefaultActivations) => menuFlowDefaultActivations.some((obj) => obj.isDownloading)
);
